import GeneralDashboardItems from './GeneralDashboard';

const AppbarModes = {
  GENERAL_DASHBOARD: GeneralDashboardItems,
};

export default AppbarModes;
